export default [
  {
    path: '/switch-budget-year',
    name: 'switchBudgetYear',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/year/BudgetYearManagement.vue'),
    meta: {},
  },
];
